<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-map-marker-path</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{$t('menuType.interactiveMaps', locale)}}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <template>        
    <v-select
      v-if="!collapseContent"
      v-model="content.InteractiveMapsID"
      item-text="Name"
      item-value="ID"
      :items="interactiveMaps"
      label="ID"
      outlined
      @change="handleChangeIsModified"
      hide-details
      style="margin-bottom: 10px;"
    />
      </template>
    </v-toolbar>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import api from '@/services/api'
export default {
  props: {
    content: {
      type: Object,
      required: true
    },
  },
  data: () => ({
    interactiveMaps: [],
  }),
  computed: {
    ...mapState('app',['collapseContent', 'locale']),
    workspaceID () {
      return this.$store.state.app.enterpriseID
    }
  },
  mounted () {
    this.getInteractiveMaps()
    if (this.content.isNew) this.handleChangeIsModified()
  },
  methods: {
    getInteractiveMaps () {
      api.getAll(`enterprises/${this.workspaceID}/interactive-maps`, true, 0, 1000, '')
        .then(response => {
          this.interactiveMaps = response.map(item => {
            return {
              ID: item.ID,
              Name: item.Name,
            }
          })
        })
    },
    handleChangeIsModified () {
      this.$store.state.app.isModified = true
    },
  }
}
</script>

<style scoped>
</style>

